import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionBancosDocumentoSeleccionarComponent {
  idCliente
  idCuenta

  constructor () {
  }

  $onInit () {
    console.info('estamos en documentos', this.idCuenta, this.idCliente)
  }
}

module.component('clienteInformacionBancosDocumentoSeleccionar', {
  controller: ClienteInformacionBancosDocumentoSeleccionarComponent,
  template,
  bindings: {
    idCliente: '<',
    idCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/bancos/documento/seleccionar/component.js